import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { CampaignsServiceProvider } from '../../api/campaigns'

const CampaignsService = CampaignsServiceProvider()
const name = 'closeCurrentCampaign'

export default (data) => (asyncAction(
  name,
  CampaignsService.closeCurrentCampaign,
  data
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/campaign/closeCurrentCampaign.js